var _path, _g, _path2, _g2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 13,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.00024H14.02V20.5021H2V5.00024Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1603)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.208 6.50613C10.34 6.50613 9.22998 7.38713 8.30598 8.12113C7.41698 8.82613 6.71498 9.38413 6.01498 9.43613C5.70498 9.45813 5.43898 9.46813 5.20498 9.47613C4.45798 9.50113 4.26898 9.51813 3.93198 9.79613C3.48998 10.1591 3.49698 11.6421 3.50098 12.5271L3.50198 12.7481V12.7521L3.50098 12.9731C3.49698 13.8591 3.48998 15.3421 3.93198 15.7051C4.26798 15.9831 4.45698 15.9991 5.20198 16.0261C5.43698 16.0331 5.70398 16.0431 6.01498 16.0661C6.71498 16.1171 7.41698 16.6751 8.30598 17.3801C9.40898 18.2551 10.775 19.3401 11.681 18.8891C12.439 18.2321 12.52 16.4901 12.52 12.7501C12.52 9.01013 12.439 7.26913 11.681 6.61113C11.534 6.53813 11.375 6.50613 11.208 6.50613ZM11.218 20.5021C9.82698 20.5021 8.44798 19.4071 7.37398 18.5551C6.88898 18.1701 6.15598 17.5881 5.90298 17.5621C5.61598 17.5401 5.36798 17.5311 5.14898 17.5251C4.35098 17.4961 3.71998 17.4751 2.97798 16.8631C1.98598 16.0461 1.99498 14.3381 2.00098 12.9661L2.00198 12.7501L2.00098 12.5341C1.99498 11.1621 1.98598 9.45513 2.97798 8.63813C3.72098 8.02613 4.35298 8.00413 5.15298 7.97713C5.37098 7.96913 5.61798 7.96113 5.90498 7.94013C6.15598 7.91313 6.88898 7.33113 7.37398 6.94613C8.77298 5.83513 10.689 4.31813 12.474 5.33513C12.505 5.35413 12.536 5.37413 12.564 5.39713C13.958 6.49213 14.02 8.55713 14.02 12.7501C14.02 16.9441 13.958 19.0091 12.564 20.1051C12.536 20.1271 12.505 20.1481 12.473 20.1661C12.059 20.4021 11.638 20.5021 11.218 20.5021Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_67_1603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 5,
    width: 4,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.084 5.90356H22.4841V19.5959H19.084V5.90356Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_67_1603)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8337 19.5959C19.6857 19.5959 19.5367 19.5519 19.4057 19.4609C19.0657 19.2249 18.9817 18.7579 19.2187 18.4169C21.6117 14.9769 21.6117 10.5279 19.2187 7.08188C18.9817 6.74188 19.0657 6.27488 19.4067 6.03788C19.7467 5.80088 20.2127 5.88588 20.4497 6.22688C23.1627 10.1309 23.1627 15.3739 20.4497 19.2749C20.3037 19.4839 20.0707 19.5959 19.8337 19.5959Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3306 17.1869C17.2036 17.1869 17.0756 17.1549 16.9576 17.0869C16.5986 16.8809 16.4746 16.4219 16.6806 16.0639C17.8516 14.0229 17.8516 11.4849 16.6806 9.43793C16.4746 9.07793 16.5996 8.61993 16.9586 8.41393C17.3186 8.21193 17.7756 8.33293 17.9816 8.69193C19.4166 11.1999 19.4166 14.3099 17.9816 16.8099C17.8426 17.0519 17.5906 17.1869 17.3306 17.1869Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/VolumeUp.527417d45d2e73496211a825aa70aca2.svg";
export { ForwardRef as ReactComponent };